<!-- 语言切换组件 基于vue-i18n -->
<template>
  <div class="language">
    <el-dropdown
      trigger="click"
      placement="bottom-end"
      @command="handleChange"
    >
      <span class="el-dropdown-link">
        {{ language }}<i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      language: this.$t('language.name')
    }
  },
  methods: {
    // 切换网站语言
    handleChange (command) {
      if (command === this.$i18n.locale) return false
      this.$i18n.locale = command
      localStorage.setItem('language', command)
      this.$store.commit('app/CHANGE_LANG')
      this.language = this.$t('language.name')
      this.$notify({
        title: this.$t('notice.title'),
        message: this.$t('notice.message'),
        duration: 1.5 * 1000,
        position: 'top-left',
        offset: 30
      })
    }
  }
}
</script>
<style lang='stylus' scoped>
.language
  cursor pointer
.el-dropdown
  color #ffffff
</style>
